<template>
  <div>
    <div id="collection_point">
      <router-link to="/students/intern" id="intern_btn" class="btn--pill blue">
        實習業務
      </router-link>
    </div>
    <student-profile-form
      lock-student-id
      :current-student="currentStudentGetter"
      @submit="submitProfile"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import StudentProfileForm from '../StudentProfileForm'
export default {
  name: 'StudentAccountSettings',
  components: {
    StudentProfileForm
  },
  computed: {
    ...mapGetters('pages/students', [
      'currentStudentGetter'
    ])
  },
  async created () {
    await this.getStudentByToken()
  },
  methods: {
    ...mapActions('pages/students', [
      'getStudentByToken',
      'updateStudentProfile'
    ]),
    async submitProfile (profile) {
      await this.updateStudentProfile(profile)
      this.getStudentByToken()
    }
  }
}
</script>
<style lang="scss" scoped>
#intern_btn {
  line-height: 35px;
  
  @media (min-width: 768px) {
    top: -50px;
    right: 0;
  }
  
  @media (max-width: 768px) { display: inline-block; }
}
</style>
